import { gql } from '@apollo/client'

export const GET_APP_TOKEN = gql`
  mutation GetAppToken($idToken: String!) {
    getAppToken(idToken: $idToken) {
      token
    }
  }
`
// UPdate this
export const GET_MEDOPS_USERS = gql`
  query (
    $attachCustomers: Boolean!
    $disabled: Boolean
    $page: Int
    $perPage: Int
    $firstName: String
    $lastName: String
    $email: String
    $customer: String
    $name: String
  ) {
    getMedopsUsers(
      page: $page
      perPage: $perPage
      firstName: $firstName
      lastName: $lastName
      email: $email
      customer: $customer
      name: $name
      disabled: $disabled
    ) {
      pagination {
        start
        limit
        length
        total
      }
      users {
        id
        email
        firstName
        lastName
        disabled
        customers @include(if: $attachCustomers) {
          value: id
          label: name
        }
        programs
      }
    }
  }
`

export enum ERROR_CODES {
  NOT_FOUND_RECORD_ERROR = 'NotFoundRecordError',
}

export interface ErrorExtension {
  response: {
    status: number
    body: {
      message: string
      errorCode?: ERROR_CODES | null
    }
  }
}
